export var FONT_SIZES={"50%":.5,"75%":.75,"100%":1,"150%":1.5,"200%":2,"300%":3,"400%":4};